import React, { CSSProperties, ClassAttributes, ReactNode } from 'react'

import { Empty } from 'antd'

export const PRESENTED_IMAGE_SIMPLE = Empty.PRESENTED_IMAGE_SIMPLE

interface EmptyProps {
  description?: string | ReactNode
  imageStyle?: CSSProperties
  image?: string | ReactNode
  children?: ReactNode
  className?: string
}

const Display = (props: EmptyProps) => {
  return <Empty {...props}>{props.children}</Empty>
}

export default Display
